// extracted by mini-css-extract-plugin
export var annBanner = "announcement-banner-module--annBanner--e938a";
export var btnClose = "announcement-banner-module--btnClose--b34c0";